import { render } from "./EditorialGalleryView.vue?vue&type=template&id=785ce421&scoped=true"
import script from "./EditorialGalleryView.vue?vue&type=script&lang=js"
export * from "./EditorialGalleryView.vue?vue&type=script&lang=js"

import "./EditorialGalleryView.vue?vue&type=style&index=0&id=785ce421&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785ce421"]])

export default __exports__